import React from 'react';

import {convertLocationParamsFoldersDocumentsToFetchParams} from 'app/documents/api';
import {DashboardFoldersFetchParamsType} from 'app/documents/types';
import {
  type InfiniteListFetcherProps,
  InfiniteListFetcherRTK,
} from 'app/general/datafetchers/InfiniteListFetcherRTK';

import {useLazyFolders} from './api';

import {
  FolderRecurrentParentSerializedType,
  FolderSerializedType,
  KBCategorySerializedType,
  KnowledgebaseSerializedType,
} from 'sweet-types';

type FolderItemSerializedType =
  | FolderSerializedType
  | KBCategorySerializedType
  | KnowledgebaseSerializedType;

export const isAncestor = (
  item: FolderItemSerializedType,
  currentlySelectedFolder: FolderRecurrentParentSerializedType
) => {
  if (
    currentlySelectedFolder == null ||
    currentlySelectedFolder.parent == null
  ) {
    return false;
  }

  if (currentlySelectedFolder.parent.id === item.id) {
    return true;
  } else {
    return isAncestor(item, currentlySelectedFolder.parent);
  }
};

export const FoldersInfiniteListFetcherRTK = (
  props: InfiniteListFetcherProps<FolderSerializedType>
) => (
  <InfiniteListFetcherRTK<FolderSerializedType, DashboardFoldersFetchParamsType>
    {...props}
    pageParam={'folders_page'}
    useLazyDataHook={useLazyFolders}
    paramsConverter={convertLocationParamsFoldersDocumentsToFetchParams}
  />
);
